document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-open-variant-modal]");
    if (!btn) return;

    e.preventDefault();
    const optionName = btn.dataset.openVariantModal;
    const modal = document.querySelector(
      `[data-variant-modal="${CSS.escape(optionName)}"]`
    );
    if (modal) {
      modal.classList.add("active");
      document.documentElement.classList.add("variant-modal-open");
    }
  });

  document.addEventListener("click", (e) => {
    const closer = e.target.closest(".variant-modal__overlay, .variant-modal__close");
    if (!closer) return;
    const modal = closer.closest(".variant-modal");
    if (modal) {
      modal.classList.remove("active");
      if (!document.querySelector(".variant-modal.active")) {
        document.documentElement.classList.remove("variant-modal-open");
      }
    }
  });

  /* ===============================
   ADD-ON PRODUCT CLICK HANDLER
=============================== */
  document.addEventListener("click", (e) => {
    const addOnCard = e.target.closest(".custom-option__add-ons");
    if (!addOnCard) return;

    const wrapper = addOnCard.closest(".product-card-wrapper");
    if (!wrapper) return;

    const variantId = wrapper.dataset.productId;
    if (!variantId) return;

    const productName = wrapper.dataset.productName;

    const addOnInput = document.querySelector(".product-variant-add-on-id");
    const drawerLabel = document.querySelector(
      ".variant-picker__drawer-button[data-open-variant-modal='custom-add_hidden_gemstone'] span"
    );

    if (addOnInput && addOnInput.value === variantId) {
      addOnInput.value = "";
      if (drawerLabel) drawerLabel.textContent = "";
      addOnCard.classList.remove("is-active");
      return;
    }

    if (addOnInput) addOnInput.value = variantId;

    if (drawerLabel) {
      drawerLabel.textContent = productName ? `: (${productName})` : "";
    }

    document
      .querySelectorAll(".custom-option__add-ons")
      .forEach((el) => el.classList.remove("is-active"));

    addOnCard.classList.add("is-active");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const variantsEl = document.getElementById("product-variants-json");
  const optionsEl = document.getElementById("product-options-json");
  if (!variantsEl || !optionsEl) return;

  let variants = [];
  let optionNames = [];
  try {
    variants = JSON.parse(variantsEl.textContent);
    optionNames = JSON.parse(optionsEl.textContent);
  } catch (err) {
    console.error("Variant JSON parse error", err);
    return;
  }

  // product.options can be names; normalize to string array
  if (optionNames.length && typeof optionNames[0] === "object") {
    optionNames = optionNames.map((o) => o.name || o);
  }

  const selected = {};

  function normalizeOptionValue(value) {
    return String(value || "")
      .replace(/\u00a0/g, " ")
      .trim()
      .toLowerCase();
  }

  function formatMoney(cents) {
    const amount = Number(cents);
    if (Number.isNaN(amount)) return "";

    const format = window.themeCurrencyCodeEnabled
      ? window.themeMoneyWithCurrencyFormat
      : window.themeMoneyFormat;

    if (window.Shopify && typeof window.Shopify.formatMoney === "function" && format) {
      return window.Shopify.formatMoney(amount, format);
    }

    return (amount / 100).toLocaleString("en-AU", {
      style: "currency",
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "AUD",
    });
  }

  window.formatThemeMoney = formatMoney;

  function getPairQuantity() {
    const active = document.querySelector(".quantity-pair-option.is-active");
    if (active) return Number(active.dataset.qty) || 1;

    const qtyInput = document.querySelector(".quantity-pair-block input[name='quantity']");
    if (qtyInput) return Number(qtyInput.value) || 1;

    return 1;
  }

  function getVariantOptionValue(variant, idx) {
    if (!variant) return "";
    if (Array.isArray(variant.options) && variant.options[idx] != null) {
      return variant.options[idx];
    }
    return variant["option" + (idx + 1)] || "";
  }

  function optionNameKey(name) {
    return normalizeOptionValue(name);
  }

  function getSelectedValue(optionName) {
    if (selected[optionName]) return selected[optionName];
    const key = optionNameKey(optionName);
    const match = Object.keys(selected).find((name) => optionNameKey(name) === key);
    return match ? selected[match] : "";
  }

  function variantOptionValues(variant) {
    const fromOptions = Array.isArray(variant.options) ? variant.options : [];
    return [variant.option1, variant.option2, variant.option3, variant.title, ...fromOptions].filter(Boolean);
  }

  function variantHasValue(variant, value) {
    const want = normalizeOptionValue(value);
    if (!want) return false;
    return variantOptionValues(variant).some((part) => normalizeOptionValue(part) === want);
  }

  function updateVariantPrice(variant) {
    const wrappers = document.querySelectorAll(".js-variant-price-wrapper");
    if (!wrappers.length || !variant) return;

    const qty = getPairQuantity();
    const formatted = formatMoney(Number(variant.price) * qty);
    if (!formatted) return;

    wrappers.forEach((wrapper) => {
      wrapper.dataset.unitPrice = String(variant.price);
      const priceItem = wrapper.querySelector(".js-variant-price");
      if (priceItem) {
        priceItem.textContent = formatted;
      } else {
        wrapper.innerHTML =
          '<div class="price price--large"><div class="price__container"><div class="price__regular">' +
          '<span class="price-item price-item--regular js-variant-price">' +
          formatted +
          "</span></div></div></div>";
      }
    });
  }

  function updateVariantBlock(variant) {
    if (!variant) return;

    const imgWrapper = document.querySelector(".js-variant-image");
    if (imgWrapper && !imgWrapper.dataset.customFeatureImage) {
      if (variant.featured_image) {
        const src = variant.featured_image.src || variant.featured_image;
        imgWrapper.innerHTML = `
        <img 
          src="${src}" 
          alt="${(variant.featured_image.alt || "").replace(/"/g, "&quot;")}" 
          loading="lazy"
          class="variant-feature-block__image"
        >
      `;
      }
    }
  }

  function findMatchingVariant(optionName, value) {
    if (optionName && value) selected[optionName] = value;

    const chosenOptions = optionNames
      .map((name, idx) => ({ name, idx, value: getSelectedValue(name) }))
      .filter((item) => item.value);

    let matches = variants.filter((variant) =>
      chosenOptions.every((item) => {
        const atIndex = getVariantOptionValue(variant, item.idx);
        if (atIndex) {
          return normalizeOptionValue(atIndex) === normalizeOptionValue(item.value);
        }
        return variantHasValue(variant, item.value);
      })
    );

    if (value) {
      const withClicked = matches.filter((variant) => variantHasValue(variant, value));
      if (withClicked.length) matches = withClicked;
    }

    if (matches.length) return matches[0];
    if (value) return variants.find((variant) => variantHasValue(variant, value)) || null;
    return null;
  }

  function updateVariantId(variantId) {
    document.querySelectorAll("input[name='id']").forEach((inp) => {
      inp.value = variantId;
      inp.disabled = false;
      inp.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function setAddButtonState(variant) {
    const productForm = document.querySelector("product-form");
    if (!productForm || typeof productForm.toggleSubmitButton !== "function") return;

    const tracked = variant && variant.inventory_management === "shopify";
    const soldOut =
      Boolean(variant) &&
      variant.available === false &&
      tracked &&
      variant.inventory_policy !== "continue";

    productForm.toggleSubmitButton(soldOut, soldOut ? window.variantStrings?.soldOut : undefined);
  }

  function updateDrawerLabel(optionName, value) {
    const key = optionName.toLowerCase().replaceAll(" ", "-");
    const btn = document.querySelector(
      `.variant-picker__drawer-button [data-selected-value="${CSS.escape(key)}"]`
    );
    if (!btn) return;
    btn.textContent = value ? ` ${value}` : "";
  }

  function clearSelectedUI(optionName) {
    document
      .querySelectorAll(`[data-option-name="${CSS.escape(optionName)}"]`)
      .forEach((el) => el.classList.remove("selected", "is-active"));
  }

  function markSelectedUI(optionName, value) {
    clearSelectedUI(optionName);
    const match = Array.from(
      document.querySelectorAll(`[data-option-name="${CSS.escape(optionName)}"]`)
    ).find(
      (el) =>
        normalizeOptionValue(el.dataset.optionValue) === normalizeOptionValue(value)
    );
    if (match) match.classList.add("selected", "is-active");
  }

  function applyVariant(variant, optionName, value) {
    if (!variant) {
      console.warn("No matching variant", selected, optionNames, variants);
      if (optionName) updateDrawerLabel(optionName, value);
      return;
    }

    optionNames.forEach((name, idx) => {
      const optVal = getVariantOptionValue(variant, idx);
      if (optVal) selected[name] = optVal;
    });

    updateVariantId(variant.id);
    updateVariantBlock(variant);
    updateVariantPrice(variant);
    setAddButtonState(variant);
    if (optionName) {
      updateDrawerLabel(optionName, selected[optionName] || value);
    }
  }

  const currentVariantId = document.querySelector("input[name='id']")?.value;
  if (currentVariantId) {
    const currentVariant = variants.find(
      (v) => String(v.id) === String(currentVariantId)
    );
    if (currentVariant) {
      optionNames.forEach((optionName, idx) => {
        const value = getVariantOptionValue(currentVariant, idx);
        if (!value) return;
        selected[optionName] = value;
        updateDrawerLabel(optionName, value);
        markSelectedUI(optionName, value);
      });
      updateVariantPrice(currentVariant);
    }
  }

  document.addEventListener("click", (e) => {
    const item = e.target.closest(".variant-option-trigger");
    if (!item) return;

    const optionName = item.dataset.optionName;
    const value = item.dataset.optionValue;
    if (!optionName || !value) return;

    selected[optionName] = value;
    clearSelectedUI(optionName);
    item.classList.add("selected", "is-active");

    let variant = findMatchingVariant(optionName, value);
    if (!variant && item.dataset.variantId) {
      variant = variants.find((entry) => String(entry.id) === String(item.dataset.variantId));
    }

    applyVariant(variant, optionName, value);

    const modal = item.closest(".variant-modal");
    if (modal) {
      modal.classList.remove("active");
      if (!document.querySelector(".variant-modal.active")) {
        document.documentElement.classList.remove("variant-modal-open");
      }
    }
  });

  // Also keep price in sync when Dawn's native picker changes the variant
  if (typeof subscribe === "function" && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variantId = event?.data?.variant?.id;
      if (!variantId) return;
      const variant = variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      const metalName = optionNames.find((name) => /metal/i.test(name));
      const chosenMetal = metalName ? getSelectedValue(metalName) : "";
      if (chosenMetal && !variantHasValue(variant, chosenMetal)) return;

      optionNames.forEach((name, idx) => {
        const optionValue = getVariantOptionValue(variant, idx);
        if (!optionValue) return;
        selected[name] = optionValue;
        updateDrawerLabel(name, optionValue);
      });
      updateVariantPrice(variant);
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".variant-modal__tab").forEach((tabBtn) => {
    tabBtn.addEventListener("click", () => {
      const modal = tabBtn.closest(".variant-modal");
      const tab = tabBtn.dataset.tab;

      modal
        .querySelectorAll(".variant-modal__tab")
        .forEach((el) => el.classList.remove("variant-modal__tab--active"));
      tabBtn.classList.add("variant-modal__tab--active");

      modal
        .querySelectorAll(".variant-modal__tab-content")
        .forEach((c) =>
          c.classList.remove("variant-modal__tab-content--active")
        );

      modal
        .querySelector(`[data-tab-content="${tab}"]`)
        ?.classList.add("variant-modal__tab-content--active");
    });
  });
});
